import React, { useState } from "react";

import {
  Menu,
  MenuTrigger,
  MenuPopover,
  MenuList,
  MenuItem,
  Button,
  Switch,
  Text,
  Tooltip,
  makeStyles,
} from "@fluentui/react-components";

import {
  MoreHorizontalRegular,
  LinkRegular,
} from "@fluentui/react-icons";

import ScvCredentialsDialog from "./ScvCredentialsDialog";

const useStyles = makeStyles({
  row: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "260px",
    gap: "16px",
  },

  labelSection: {
    display: "flex",
    flexDirection: "column",
    gap: "2px",
  },

  label: {
    fontWeight: 600,
  },

  description: {
    fontSize: "12px",
    opacity: 0.75,
  },
});

export default function SalesforceMoreMenu({
  scvEnabled,
  syncEnabled,
  // eslint-disable-next-line no-unused-vars
  onToggleScv,
  // eslint-disable-next-line no-unused-vars
  onToggleSync,
  onGenerateCredentials,
}) {
  const styles = useStyles();

  const [openCredentials, setOpenCredentials] =
    useState(false);

  // ✅ CONTROL MENU
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <Menu
        open={menuOpen}
        onOpenChange={(_, data) =>
          setMenuOpen(data.open)
        }
        positioning="below-end"
      >
        <MenuTrigger disableButtonEnhancement>
          <Tooltip
            content="More Settings"
            relationship="label"
          >
            <Button
              appearance="subtle"
              icon={<MoreHorizontalRegular />}
            />
          </Tooltip>
        </MenuTrigger>

        <MenuPopover>
          <MenuList>

            {/* SCV ENABLE — read-only status; toggling is not yet supported
                on the backend, so the switch is disabled until an endpoint exists. */}
            <MenuItem
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
            >
              <div className={styles.row}>
                <div className={styles.labelSection}>
                  <Text className={styles.label}>
                    Salesforce Voice (SCV) Enabled
                  </Text>

                  <Text className={styles.description}>
                    Enable Salesforce Voice (SCV) integration
                  </Text>
                </div>

                <Tooltip content="Read-only — use the Connect button to authenticate the org for SCV" relationship="label">
                  <Switch
                    checked={Boolean(scvEnabled)}
                    disabled
                    label={scvEnabled ? "Enabled" : "Disabled"}
                  />
                </Tooltip>
              </div>
            </MenuItem>

            {/* SYNC ENABLE — same: read-only until backend supports toggling. */}
            <MenuItem
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
            >
              <div className={styles.row}>
                <div className={styles.labelSection}>
                  <Text className={styles.label}>
                    Sync Enabled
                  </Text>

                  <Text className={styles.description}>
                    Enable Sync integration
                  </Text>
                </div>

                <Tooltip content="Read-only — use the Connect button to authenticate the org for Sync" relationship="label">
                  <Switch
                    checked={Boolean(syncEnabled)}
                    disabled
                    label={syncEnabled ? "Enabled" : "Disabled"}
                  />
                </Tooltip>
              </div>
            </MenuItem>
            {
              scvEnabled && <MenuItem
                icon={<LinkRegular />}
                onClick={() => {
                  setMenuOpen(false);
                  setOpenCredentials(true);
                }}
              >
                Generate Salesforce Voice (SCV) Credentials
              </MenuItem>
            }
          </MenuList>
        </MenuPopover>
      </Menu>

      {/* DIALOG */}
      <ScvCredentialsDialog
        open={openCredentials}
        onOpenChange={(_, data) =>
          setOpenCredentials(data.open)
        }
        onGenerateCredentials={
          onGenerateCredentials
        }
      />
    </>
  );
}